import { Konzept } from "@/types/Kommune";
import DokumenteService from "./DokumenteService";

class KonzeptService extends DokumenteService {
  constructor() {
    super("/konzept");
  }

  /**
   * @param id Kommunen Id
   */
  public getKonzepte(id: number | string): Promise<Konzept[]> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() => this.requestService.get<Konzept[]>(this.root + `/${id}`));
  }

  /**
   * @param id Konzept Id
   * @param konzept Konzept data
   */
  public updateKonzept(
    id: number | string,
    konzept: Konzept,
  ): Promise<Konzept> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() =>
        this.requestService.post<Konzept>(this.root + `/${id}`, konzept),
      );
  }

  /**
   * @param konzept Konzept data
   */
  public createKonzept(konzept: Konzept): Promise<Konzept> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() => this.requestService.put<Konzept>(this.root + `/`, konzept));
  }

  /**
   * @param id Konzept Id
   */
  public deleteKonzept(id: number | string): Promise<void> {
    // check if user is authenticated before request
    return this.authService
      .checkAuthentication()
      .then(() => this.requestService.delete<void>(this.root + `/${id}`));
  }
}

const konzeptServiceInstance = new KonzeptService();

export { konzeptServiceInstance };
export default KonzeptService;
